import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { DashboardTradesCharts } from '../dashboard/trades/charts/dashboard-trades-charts';
import { DashboardTradesProfitChart } from '../dashboard/trades/profit-chart/dashboard-trades-profit-chart';
import { DashboardTradesAllocations } from '../dashboard/trades/allocations/dashboard-trades-allocations';
import { Text } from '../../../components/app/text/text';
import { DashboardTradesCards } from '../dashboard/trades/cards/dashboard-trades-cards';
import { PageHeadline } from '../../../components/app/page-headline/page-headline';
import { Button } from '../../../components/app/form/button/button';
import { useRootStore } from '../../../providers/root-store-provider';
import { ShareTypeEnum } from '../../../defs/api';
import { Headline } from '../../../components/app/headline/headline';
import { BannerSharedPortfolio } from '../../../components/app/banner/shared-portfolio/banner-shared-portfolio';

type SharedPortfolioType = {
    name: string;
    numberOfAssets: number;
};

const SharedPortfolio: React.FC<SharedPortfolioType> = observer(({ name }: SharedPortfolioType) => {
    const { t } = useTranslation();

    const rootStore = useRootStore();
    const { authStore, portfolioStore } = rootStore;

    const user = authStore.userProfile;

    return (
        <div className="relative py-medium">
            <PageHeadline
                title={name}
                mobileBreakUnder="xl"
                before={
                    <Text uppercase variant={'gray'} size={'xsmall'} bold>
                        {t('pages.sharedPortfolio.label')}
                    </Text>
                }
                action={
                    <>
                        {!user && (
                            <BannerSharedPortfolio onDiscountClick={portfolioStore.openSharedPortfolioDiscountModal} />
                        )}
                    </>
                }
            />
            <div className="relative">
                <>
                    <DashboardTradesCards shared />

                    <DashboardTradesCharts />

                    <DashboardTradesProfitChart />

                    <DashboardTradesAllocations />
                </>
                {portfolioStore.sharedPortfolio?.shareType !== ShareTypeEnum.Public && !user && (
                    <div className="absolute inset-[-2rem] z-[500] flex items-start justify-center bg-[linear-gradient(180deg,rgba(255,255,255,0.4)_0%,rgba(255,255,255,0.6)_50%)] px-0 py-[20%] backdrop-blur-[0.3rem]">
                        <div className="flex max-w-[50rem] flex-col items-center gap-medium rounded-large border border-border bg-surface p-vlarge shadow-large">
                            <Headline level={2} align={'center'}>
                                {t('pages.sharedPortfolio.notLoggedIn')}
                            </Headline>
                            <div className="flex items-center gap-medium">
                                <Button
                                    variant={'positive'}
                                    size={'large'}
                                    gradient
                                    shadow
                                    onClick={() => authStore.authDialogStore.setLoginActive()}
                                >
                                    {t('pages.layout.header.signIn')}
                                </Button>
                                <Button
                                    variant={'primary'}
                                    size={'large'}
                                    onClick={() => {
                                        authStore.authDialogStore.setSignupActive();
                                    }}
                                >
                                    {t('pages.layout.header.registration')}
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
});

export default SharedPortfolio;
